<template>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 my-3">
            <div class="inner-box">
                <div class="inner-content">
                    <h4 class="mb-4"><b>{{ reference ? reference.heading : '' }}</b></h4>
                    <div v-html="reference ? reference.text : ''"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "RomanReferences",
    props : { reference : Object}
};
</script>
